<template>
    <GridButton
        v-if="value && row"
        :row="row"
        text=""
        buttonType="Custom"
        icon="fa-map-location-dot"
        :onClick="onClick"
    ></GridButton>
</template>

<script lang="ts" setup>
import { GridButton } from '@/components';
import { useDialog } from '@/composeables';
import { $ti } from '@/locize';
import type { MapPoint, TrackingDeviceWithRaceContestantPosition } from '@/objects/generated';
import TrackingDevicePositionView from './TrackingDevicePositionView.vue';
import { useContestantStore } from '@/stores';

const { GetDisplayName } = useContestantStore();

/**
 * This only wraps the GridButton so we can hide it if we dont have a value
 */
const props = defineProps<{
    /**
     * The value we want to show
     */
    value: MapPoint | null;

    /**
     * The entire datarow
     */
    row?: TrackingDeviceWithRaceContestantPosition | null;
}>();

const onClick = (row: TrackingDeviceWithRaceContestantPosition) => {
    let position = props.value;

    useDialog().Ok({
        title: $ti('positiondisplay.showposition', {
            lat: position?.Latitude,
            lon: position?.Longitude,
            name: GetDisplayName(row.RaceContestantID),
        }),
        body: TrackingDevicePositionView,
        componentProps: { value: props.row ?? null },
        options: {
            Size: 'lg',
        },
    });
};
</script>
